import { useAuth } from '@/app/AuthContext';
import { Permission } from '@/types/permission';
import { Button } from './Button';
import { EmptyState } from './EmptyState';
import { Icon } from './Icon';

interface Props {
  unitName?: string;
  scope?: 'unit' | 'company' | 'production';
}

/**
 * Financial figures exist only after an XLSX import. Until then every financial
 * surface renders this state — the product never invents or seeds numbers.
 */
export function NoFinancialData({ unitName, scope = 'unit' }: Props) {
  const { can } = useAuth();

  const description =
    scope === 'company'
      ? 'Консолидированные показатели появятся после первого импорта отчёта ОПУ.'
      : scope === 'production'
        ? `Затраты цеха${unitName ? ` «${unitName}»` : ''} появятся после импорта отчёта ОПУ.`
        : `Финансовые данные${unitName ? ` объекта «${unitName}»` : ''} появятся после импорта отчёта ОПУ.`;

  return (
    <EmptyState
      title="Данные ещё не загружены"
      description={description}
      icon="inbox"
      action={
        can(Permission.UPLOAD_IMPORT) ? (
          <Button variant="primary">
            <Icon name="upload" size={15} />
            Загрузить отчёт
          </Button>
        ) : (
          <span style={{ fontSize: 12.5, opacity: 0.7 }}>
            Загрузку выполняет владелец или бухгалтер.
          </span>
        )
      }
    />
  );
}
